import PropTypes from "prop-types"
import { IconButton } from "@mui/material"
import { Close } from "@mui/icons-material"
import "./style.scss"

export default function FormError({ errorMessage, clearError, nonRemovable }) {
  return <div className="component_login-form-error">
    <div>{errorMessage}</div>
    {!nonRemovable && <IconButton className="close-error-btn" onClick={clearError} size="large">
      <Close />
    </IconButton>}
  </div>
}

FormError.propTypes = {
  errorMessage: PropTypes.string.isRequired,
  clearError: PropTypes.func,
  nonRemovable: PropTypes.bool,
}
